import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
    interface Palette {
        bgBlue: {
            main: string;
        };
        bgBlueLight: {
            main: string;
        };
        bgDark: {
            main: string;
        };
        bgGrey: {
            main: string;
        };
        bgRed: {
            main: string;
        };
        bgWhite: {
            main: string;
        };
        bgYellow: {
            main: string;
        };
        darkBlue: {
            main: string;
        };
        green: {
            main: string;
        };
        mlBlue: {
            main: string;
        };
        mlGreen: {
            main: string;
        };
        mlRed: {
            main: string;
        };
        mlYellow: {
            main: string;
        };
    }
    interface PaletteOptions {
        bgBlue: {
            main: string;
        };
        bgBlueLight: {
            main: string;
        };
        bgDark: {
            main: string;
        };
        bgGrey: {
            main: string;
        };
        bgRed: {
            main: string;
        };
        bgWhite: {
            main: string;
        };
        bgYellow: {
            main: string;
        };
        darkBlue: {
            main: string;
        };
        green: {
            main: string;
        };
        mlBlue: {
            main: string;
        };
        mlGreen: {
            main: string;
        };
        mlRed: {
            main: string;
        };
        mlYellow: {
            main: string;
        };
    }
    interface ThemeOptions {
        themeName: string;
    }
}

declare module '@mui/material' {
    interface TextFieldPropsColorOverrides {
        bgBlue: true;
        bgBlueLight: true;
        bgDark: true;
        bgGrey: true;
        bgRed: true;
        bgWhite: true;
        bgYellow: true;
        darkBlue: true;
        green: true;
        mlBlue: true;
        mlGreen: true;
        mlRed: true;
        mlYellow: true;
    }
    interface CheckboxPropsColorOverrides {
        bgBlue: true;
        bgBlueLight: true;
        bgDark: true;
        bgGrey: true;
        bgRed: true;
        bgWhite: true;
        bgYellow: true;
        darkBlue: true;
        green: true;
        mlBlue: true;
        mlGreen: true;
        mlRed: true;
        mlYellow: true;
    }
    interface SvgIconPropsColorOverrides {
        bgBlue: true;
        bgBlueLight: true;
        bgDark: true;
        bgGrey: true;
        bgRed: true;
        bgWhite: true;
        bgYellow: true;
        darkBlue: true;
        green: true;
        mlBlue: true;
        mlGreen: true;
        mlRed: true;
        mlYellow: true;
    }
}

const palette = {
    bgBlue: {
        main: '#1C4E7150',
    },
    bgBlueLight: {
        main: '#1C4E7110',
    },
    bgDark: {
        main: '#13364f',
    },
    bgGrey: {
        main: '#F6F6F6',
    },
    bgRed: {
        main: '#E72D5030',
    },
    bgWhite: {
        main: '#F9FAFC',
    },
    bgYellow: {
        main: '#FCC04130',
    },
    darkBlue: {
        main: '#081627',
    },
    green: {
        main: '#44b700',
    },
    mlBlue: {
        main: '#4EC1ED',
    },
    mlGreen: {
        main: '#8DBF30',
    },
    mlRed: {
        main: '#E72D50',
    },
    mlYellow: {
        main: '#FCC041',
    },
    primary: {
        main: '#1C4E71',
    },
};

const themeName = 'Missing-Link Colors';

const theme = createTheme({
    cssVariables: {
        nativeColor: true,
    },
    palette,
    themeName,
    typography: {
        fontFamily: 'SF Pro Display, sans-serif',
    },
});

export default theme;
